<template>
  <div class="qualification-binding">
    <van-nav-bar title="绑定小店资质" left-arrow fixed placeholder @click-left="$router.go(-1)" />
    <div style="padding: 25px 15px">
      <p class="title">
        请登录抖店后台，在【店铺】-【店铺官方账号】功能中生成绑定二维码，使用本账号扫描二维码进行绑定；账号绑定成功后，当前达人账号将默认使用店铺收款账户；
      </p>

      <div class="step" v-for="(item, idx) in stepList" :key="idx">
        <p class="step-title">{{ item.title }}</p>
        <p class="step-info">{{ item.info }}</p>
        <el-image :src="item.img" fit="cover"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      stepList: [
        {
          title: "步骤一：进入账号绑定页面",
          info: "登录抖店后台，打开【店铺】-【店铺官方账号】，情仔细阅读绑定说明后选择【立即绑定】",
          img: require("@/assets/images/simulation/binding1.jpg"),
        },
        {
          title: "步骤二：获取绑定二维码",
          info: "点击【立即绑定】后，可获取绑定二维码",
          img: require("@/assets/images/simulation/binding2.jpg"),
        },
        {
          title: "步骤三：抖音账号扫描二维码",
          info: "使用当前抖音账号扫码后，请确认店铺信息、并阅读重要提示和用户授权协议，确认是否要接受店铺绑定",
          img: require("@/assets/images/simulation/binding3.jpg"),
        },
        {
          title: "步骤四：确认绑定",
          info: "若在抖音短视频内选择接受绑定，则在抖店后台可再次确认要绑定的抖音账号，点击【确定绑定】后，即完成绑定",
          img: require("@/assets/images/simulation/binding4.jpg"),
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.qualification-binding {
  ::v-deep .van-nav-bar {
    background-color: #000;
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .title {
    font-size: 16px;
    line-height: 1.8;
  }
  .step {
    margin-top: 20px;
    .step-title {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: bold;
    }
    .step-info {
      margin-bottom: 20px;
      color: #909399;
      font-size: 16px;
      line-height: 1.8;
    }
  }
}
</style>